var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFidelityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 253",
    enableBackground: "new 0 0 256 253",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.341,213.86l-40.499-41.509c-11.64-10.235-13.09-28.244-2.811-39.928l0,0c10.235-11.64,28.288-13.046,39.928-2.811 l4.041,3.514l4.041-3.514c11.86-10.278,29.693-8.829,39.928,2.811l0,0c10.278,11.86,8.829,29.693-2.811,39.928L127.341,213.86z  M2,61h252v8c-0.301,14.158-9.11,25.609-22,29.554V233h22v18H2v-18h22V98.576C11.625,94.302,2,82.678,2,69V61z M42,98.594V233h172 V98.5c-13.228-3.738-22.954-15.728-22.954-30.154c0,10.448-9.63,31.447-31.363,31.447c-24.053,0-31.464-20.395-31.464-31.447 c0,11.855-9.513,31.47-31.202,31.47c-24.971,0-31.727-24.992-31.727-31.47C65.29,82.895,55.402,94.966,42,98.594z M222.832,22H223V2 H34v20L2,54h252L222.832,22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFidelityIcon);
export default __webpack_public_path__ + "static/media/fidelityIcon.52b7a9e82b66a38bc5b682179190496e.svg";
export { ForwardRef as ReactComponent };